<header class="page-header">
  <div class="header-top-band" aria-hidden="true"></div>
  <svg class="header-border" viewBox="0 0 375 6" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M0 0H121.5L111.908 6H0V0Z" fill="#1758A7" />
    <path d="M92.9894 0H206L200.522 6H84.5L92.9894 0Z" fill="#002F7B" />
    <path d="M172.508 0H283.983L290.5 6H169L172.508 0Z" fill="#1746FF" />
    <path d="M375 0H253.5L262.048 6H375V0Z" fill="#38BEEF" />
  </svg>
  <div class="header-contents">
    <div class="header-contents-inner">
      <div class="header-logo-container">
        <button type="button" class="logo-btn" aria-label="オフィシャルHPを開く" (click)="openOfficialSite()">
          <img class="header-logo" ngSrc="/page-header/logo.svg" width="142" height="44" alt="第一生命" priority />
        </button>
      </div>
    </div>
  </div>
</header>
